export enum SystemRoleEnum {
  SYSTEM_GLOBAL_ADMIN = "SystemGlobalAdmin",
  ACCOUNT_GLOBAL_ADMIN = "AccountGlobalAdmin",
  ADMINISTRATOR = "Administrator",
  CUSTOMER = "Customer"
}



